import { DrawOpts, ShapeOptions } from '../../../../types';
import { shapeNames } from '../../../../shapes/constants';

const getNoteIndicatorOptions = (options: ShapeOptions) => ({
  noteIndicatorStyle: options[shapeNames.noteIcon] || {},
});

const shouldNoteIndicatorShow = ({ model }: Pick<DrawOpts, 'model'>) => model?.description != null;

export const drawNoteIndicator = ({ options, group, model }: Omit<DrawOpts, 'size'>) => {
  const { noteIndicatorStyle } = getNoteIndicatorOptions(options);

  group.addShape('image', {
    name: shapeNames.noteIcon,
    className: shapeNames.noteIcon,
    draggable: true,
    attrs: {
      ...noteIndicatorStyle,
    },
    visible: shouldNoteIndicatorShow({ model }),
  });
};

export const updateNoteIndicator = ({ group, model }: Omit<DrawOpts, 'options' | 'size'>) => {
  const noteIndicatorShape = group.findByClassName(shapeNames.noteIcon);

  if (!noteIndicatorShape) return;

  if (shouldNoteIndicatorShow({ model })) {
    noteIndicatorShape.show();
  } else {
    noteIndicatorShape.hide();
  }
};
